import { createPromiseAction } from "@adobe/redux-saga-promise";

export const MEDICATION_SEARCH = "MEDICATION_SEARCH";
export const MEDICATION_SEARCH_TRIGGER = "MEDICATION_SEARCH.TRIGGER";

/** ACTION TYPES */
export interface MedicationSearchAction {
  type: typeof MEDICATION_SEARCH;
  payload: { searchText: string };
}

/** ACTION CREATORS */
export const medicationSearchPromise = createPromiseAction(
  MEDICATION_SEARCH,
  (searchText: string) => ({ searchText })
);
